import React, { useState } from 'react';
import UserItem from './UserItem';

const UsersSection = () => {
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 10;

    const users = [
        { name: 'User 1', status: 'active' },
        { name: 'User 2', status: 'inactive' },
        { name: 'User 3', status: 'active' },
        { name: 'User 4', status: 'inactive' },
        { name: 'User 5', status: 'active' },
        { name: 'User 6', status: 'inactive' },
        { name: 'User 7', status: 'active' },
        { name: 'User 8', status: 'inactive' },
        { name: 'User 9', status: 'active' },
        { name: 'User 10', status: 'inactive' },
        { name: 'User 11', status: 'active' },
        { name: 'User 12', status: 'inactive' },
        // Add more users as needed...
    ];

    const filteredUsers = users.filter(user =>
        user.name.toLowerCase().includes(search.toLowerCase())
    );

    // Pagination logic
    const totalPages = Math.ceil(filteredUsers.length / ITEMS_PER_PAGE);
    const paginatedUsers = filteredUsers.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setCurrentPage(1); // Reset to page 1 after search
    };

    const handlePageChange = (direction) => {
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        } else if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const styles = {
        paginationContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '20px',
            paddingBottom: '30px', // Add padding to prevent touching the border
        },
        paginationButton: {
            margin: '0 10px',
            padding: '10px 20px',
            cursor: 'pointer',
            border: '1px solid rgba(0, 0, 0, 0.2)',
            borderRadius: '5px',
            backgroundColor: '#e0e0e0', // Light gray background for inactive state
            color: '#333',
            fontSize: '16px',
            transition: 'background-color 0.2s ease, color 0.2s ease',
            outline: 'none',
            boxShadow: 'none', // Remove focus border shadow
        },
        disabledButton: {
            backgroundColor: 'white',
            opacity: 0.5,
            cursor: 'not-allowed',
        },
        activeButton: {
            backgroundColor: '#b0b0b0', // Slightly darker gray for active state
            color: '#fff',
        },
        paginationPage: {
            margin: '0 10px',
            padding: '10px 15px',
            fontSize: '16px',
            color: '#333',
        },
        noItemsMessage: {
            fontSize: '18px',
            color: '#333',
            textAlign: 'center',
            width: '100%', // Full width of the container
            padding: '15px',
            backgroundColor: '#f8f9fa', // Light background
            borderRadius: '8px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', // Subtle shadow
            marginTop: '20px', // Spacing from the top
        },
    };

    return (
        <div className="card">
            <div className="header">
                <h2><strong>Users</strong></h2>
                <div className="org-section-search-bar">
                    <input 
                        type="text" 
                        placeholder="Search for users..." 
                        value={search} 
                        onChange={handleSearchChange} 
                        className="form-control" 
                    />
                </div>
            </div>
            <div className="body">
                <ul className="list-unstyled">
                    {paginatedUsers.map((user, index) => (
                        <UserItem key={index} name={user.name} status={user.status} />
                    ))}
                </ul>
                {filteredUsers.length === 0 && <p style={styles.noItemsMessage}>No users found.</p>}
            </div>
            {/* Pagination controls */}
            {totalPages > 1 && (
                <div style={styles.paginationContainer}>
                    <button 
                        style={{ 
                            ...styles.paginationButton, 
                            ...(currentPage === 1 ? styles.disabledButton : styles.activeButton),
                        }}
                        onClick={() => handlePageChange('prev')}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <span style={styles.paginationPage}>{currentPage} / {totalPages}</span>
                    <button 
                        style={{ 
                            ...styles.paginationButton, 
                            ...(currentPage === totalPages ? styles.disabledButton : styles.activeButton),
                        }}
                        onClick={() => handlePageChange('next')}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default UsersSection;
